import { render, staticRenderFns } from "./provinceBar.vue?vue&type=template&id=49d11793&scoped=true&"
import script from "./provinceBar.vue?vue&type=script&lang=js&"
export * from "./provinceBar.vue?vue&type=script&lang=js&"
import style0 from "./provinceBar.vue?vue&type=style&index=0&id=49d11793&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d11793",
  null
  
)

export default component.exports